// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".constructor-trainer-details{padding-left:1rem;padding-right:1rem}@media (min-width: 768px){.constructor-trainer-details{padding-left:0px;padding-right:0px}}.constructor-trainer-details .card-profile:after{opacity:0!important}.constructor-trainer-details__img{width:287px;}@media screen and (max-width:768px){.constructor-trainer-details__img{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
